/**
 * Created by MMCK_010 on 2017/10/25.
 */
import clickoutside from './clickoutside'
import transfer from './transfer-dom'

function controlShow (el, ref, vnode) {
    if (localStorage.permissionArr === undefined) {
        return
    }
    let permissionArr = JSON.parse(localStorage.permissionArr)
    let code = ref.value
    if (!permissionArr[code]) {
        // el.remove()
        el.style.display = "none"
    }
}

const directive = {
    permission: {
        bind: controlShow,
        update: controlShow
    },
    clickoutside: clickoutside,
    transferDom: transfer
}

export default directive



// WEBPACK FOOTER //
// ./src/directive/index.js